<script setup lang="ts">
import BaseNotificationBarComponent from '@/components/notifications/NotificationBarComponents/BaseNotificationBarComponent.vue'
import { IconNotification } from '@tabler/icons-vue'
const { t } = useI18n()

const offCanvasVisibility = ref(false)

const notificationsStore = useNotificationStore()
notificationsStore.subscribe()
const { notificationsIndex } = storeToRefs(notificationsStore)

const eventStore = useEventStore()
if (!eventStore.getId()) {
  notificationsStore.filterByEvent = false
}

const readNotifications = async () => {
  notificationsStore.getNotifications()
  offCanvasVisibility.value = true
  notificationsStore.removeNotificationWarning()
}

const loadPage = async url => {
  notificationsStore.getNotifications(url)
}

const getColorToast = type => {
  switch (type) {
    case 'success':
      return '#198754'

    case 'error':
      return '#dc3545'
  }
}
</script>

<template>
  <div>
    <CDropdown variant="nav-item" :auto-close="false" @click="readNotifications()">
      <CDropdownToggle placement="bottom-end" :caret="false">
        <!--        <CIcon class="mt-2 mx-1" icon="cil-bell" size="lg" />-->
        <IconNotification stroke-width="1" size="35" class=" " />
        <CBadge
          v-if="notificationsStore.shouldShowNotificationWarning()"
          class="position-absolute top-1 end-0"
          color="danger-gradient"
          shape="rounded-pill"
        >
          !
        </CBadge>
      </CDropdownToggle>
    </CDropdown>
    <COffcanvas
      placement="end"
      :visible="offCanvasVisibility"
      @hide="
        () => {
          offCanvasVisibility = !offCanvasVisibility
        }
      "
    >
      <COffcanvasHeader>
        <COffcanvasTitle>{{ t('Notifications') }}</COffcanvasTitle>
        <CCloseButton class="text-reset" @click="offCanvasVisibility = false" />
      </COffcanvasHeader>
      <COffcanvasBody class="pt-0">
        <CFormSwitch
          :label="t('Filter by event')"
          v-if="eventStore.getId()"
          id="formSwitchCheckDefault"
          v-model="notificationsStore.filterByEvent"
        />
        <template v-for="(item, index) in notificationsIndex.data" :key="index">
          <BaseNotificationBarComponent :notification="item" />
        </template>
        <div v-if="!notificationsIndex.data || notificationsIndex.data.length === 0" class="py-5 mt-5 text-center">
          <CImage fluid src="/img/app/empty-box.png" style="max-width: 170px; width: 100%" class="mb-3" />
          <p class="text-blue-muted">{{ t('This place is empty') }}</p>
        </div>
        <CRow class="mt-4" v-if="notificationsIndex.links && notificationsIndex.links.length > 3">
          <CCol>
            <CPagination :aria-label="`${section} navigation`">
              <CPaginationItem
                v-for="(pag, index) in notificationsIndex.links"
                :key="index"
                :active="pag.active"
                href="#"
                @click="
                  e => {
                    e.preventDefault()
                    if (!pag.disabled) {
                      loadPage(pag.url)
                    }
                  }
                "
                :disabled="pag.disabled"
              >
                <span v-html="t(pag.label)"></span>
              </CPaginationItem>
            </CPagination>
          </CCol>
        </CRow>
      </COffcanvasBody>
    </COffcanvas>

    <CToaster placement="top-end" visible>
      <CToast :autohide="false" visible v-for="(toast, index) in notificationsStore.getToasts()" :key="index">
        <CToastHeader closeButton>
          <svg
            class="rounded me-2"
            width="20"
            height="20"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid slice"
            focusable="false"
            role="img"
          >
            <rect width="100%" height="100%" :fill="getColorToast(toast.type)"></rect>
          </svg>
          <span class="me-auto fw-bold"></span>
          <small>{{ toast.time }}</small>
        </CToastHeader>
        <CToastBody>
          <strong v-if="toast.message.event_name">{{ toast.message.event_name }}</strong>
          <p class="mb-3 w-100 whitespace-normal" style="white-space: normal">
            {{ toast.message.message }}
            <br />
            <a :href="toast.message.url" target="_blank" rel="noopener noreferrer">
              {{ t('Click here') }}
            </a>
          </p>
        </CToastBody>
      </CToast>
    </CToaster>
  </div>
</template>
<style>
.dropdown-item.active,
.dropdown-item:active {
  color: #4f5d73;
  background: #d8dbe0;
}
</style>
